import { Component, OnInit, AfterViewInit, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
declare var $: any;

@Component({
  selector: 'app-donut',
  templateUrl: './doughnut.component.html',
  styleUrls: ['./doughnut.component.css']
})

export class DoughnutComponent implements OnInit {
  @Input() CategorisedTicketcount: any;
  @Input() TotalTicketcount: any;
  constructor() { }
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.RenderDoughnutChartsWithLabel();
  }
  RenderDoughnutChartsWithLabel() {    
    var TotalTicket = this.TotalTicketcount;
    var CatTicket = this.CategorisedTicketcount;
    var NonCatTicket = TotalTicket - CatTicket;
    var repeatedPercentage = (this.CategorisedTicketcount*100)/TotalTicket;
    let that = this;
    d3.select("#deepDonughtchart").html("");
    d3.select("#deepDonughtchart").classed('piewithlables', true);
    //console.log('pie width : ' + pieChartContainer.clientWidth)
    var w = 180;//d3.select("#deepDonughtchart").node().offsetWidth;;
    var h = 150;

    var margin = {
      top: 0,
      bottom: 0,
      left: 10,
      right: 10,
    };
    var width = w - margin.left - margin.right;
    var height = h - margin.top - margin.bottom;
    var svg = d3.select("#deepDonughtchart")
      .append('svg')
      .classed("resizableSVG", true)
      .attr('id', 'svg_deepDonughtchart')
      .attr('xmlns', "http://www.w3.org/2000/svg")
      .attr('viewBox', "0 0 " + width + " " + height + "")
      .attr('width', width)
      .attr('height', height)
      .attr('preserveAspectRatio', 'xMidYMid meet')
      .style('overflow', 'visible')
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    //var svg = d3.select("body").append("svg")
    //.attr("width", 960)
    //.attr("height", 500)
    //.append("g");

    svg.append("g")
      .attr("class", "slices");
    svg.append("g")
      .attr("class", "labels");
    svg.append("g")
      .attr("class", "lines");
    var radius = Math.min(width, height) / 2;
    var color = ['#6808D8', '#008DFE'];
    var data = [NonCatTicket, CatTicket];



    var pie = d3.pie().value(d => d);
    var arc = d3.arc().innerRadius(radius * 0.8).outerRadius(radius * 0.6);

    var outerArc = d3.arc()
      .outerRadius(radius * 0.9)
      .innerRadius(radius * 0.9);

    svg.attr("transform", "translate(" + ((width / 2) + 130) + "," + ((height / 2) - 20) + ")");

    svg.selectAll('path')
      .data(pie(data))
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', (d, i) => {
        return color[i % color.length];
      })
    // .attr('fill', (d,i)=> color(i));
    svg.append('g').classed('labels', true);
    svg.append('g').classed('lines', true);


    var polyline = svg.select('.lines')
      .selectAll('polyline')
      .data(pie(data))
      .enter().append('polyline')
      .style('fill', 'none')
            //.style("stroke", function (d, i) { return colors(i); })
            .style("stroke-width", "1px")
            .attr("stroke", "#707070")
            .attr("stroke-dasharray", "1")
      .attr('points', function (d) {

        // see label transform function for explanations of these three lines.
        var pos = outerArc.centroid(d);
        pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
        return [arc.centroid(d), outerArc.centroid(d), pos]
      });



    var label = svg.select('.labels').selectAll('text')
      .data(pie(data))
      .enter().append('text')
      .attr('dy', '.35em')
      .html(function (d) {
        return `${d3.format(",")(d.data)}`;
      })
      .attr('transform', function (d) {
        var pos = outerArc.centroid(d);
        pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
        return 'translate(' + pos + ')';
      })
      .style('text-anchor', function (d) {
        return (midAngle(d)) < Math.PI ? 'start' : 'end';
      });

    svg.append('text')
      .attr('class', 'toolCircle')
      .attr('dy', -5) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
      .html(repeatedPercentage != 100 ? repeatedPercentage.toFixed(2)+'%' : repeatedPercentage +'%') // add text to the circle.
      .style('font-size', '11px')
      .style('text-anchor', 'middle');
    svg.append('text')
      .attr('class', 'toolCircle')
      .attr('dy', +12) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
      .html('Repeated') // add text to the circle.
      .style('font-size', '11px')
      .style('text-anchor', 'middle');

    function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.RenderDoughnutChartsWithLabel();
  }
}